import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { getWarehouseDetail } from "../../redux/warehouse/warehouseSlice";
import { setModal } from "../../redux/rightModalSlice";

export default function WarehouseCard({ warehouse, onDelete }) {
    const dispatch = useDispatch();
    const token = localStorage.getItem('installamelo-auth-token');
    const positionsCount = warehouse.positions?.length || 0;

    const openModal = (mode, e) => {
        if (e) e.stopPropagation();
        dispatch(getWarehouseDetail({ warehouseId: warehouse._id, token }));
        dispatch(setModal({ mode, id: warehouse._id, percentuageWidth: mode === 'products' ? 80 : 45 }));
    };

    const address = [warehouse.address, warehouse.postalCode, warehouse.city, warehouse.province ? `(${warehouse.province})` : '']
        .filter(Boolean).join(' ');

    return (
        <div
            className="bg-white rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all cursor-pointer"
            onClick={() => openModal('view')}
        >
            <div className="p-4">
                <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                            <DynamicIcon iconClass="fa-solid fa-warehouse text-blue-600" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-900 leading-tight">
                                {warehouse.name || "Magazzino senza nome"}
                            </h3>
                            {address && (
                                <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1">
                                    <DynamicIcon iconClass="fa-solid fa-location-dot text-gray-400" />
                                    {address}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-between">
                    <span className="inline-flex items-center gap-1.5 text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full font-medium">
                        <DynamicIcon iconClass="fa-solid fa-table-cells-large text-gray-400" />
                        {positionsCount} posizion{positionsCount === 1 ? 'e' : 'i'}
                    </span>

                    <div className="flex gap-1">
                        <button
                            className="p-1.5 hover:bg-blue-50 rounded text-blue-600"
                            onClick={(e) => openModal('products', e)}
                            title="Prodotti"
                        >
                            <DynamicIcon iconClass="fa-solid fa-boxes-stacked text-sm" />
                        </button>
                        <button
                            className="p-1.5 hover:bg-gray-100 rounded text-gray-600"
                            onClick={(e) => openModal('edit', e)}
                            title="Modifica"
                        >
                            <DynamicIcon iconClass="fa-solid fa-pen text-sm" />
                        </button>
                        <button
                            className="p-1.5 hover:bg-gray-100 rounded text-gray-600"
                            onClick={(e) => openModal('view', e)}
                            title="Visualizza"
                        >
                            <DynamicIcon iconClass="fa-solid fa-eye text-sm" />
                        </button>
                        <button
                            className="p-1.5 hover:bg-red-50 rounded text-red-500"
                            onClick={(e) => { e.stopPropagation(); onDelete?.(warehouse); }}
                            title="Elimina"
                        >
                            <DynamicIcon iconClass="fa-solid fa-trash text-sm" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
